import DEG_TO_RAD = PIXI.DEG_TO_RAD;

/**
 * the lights around the prize wheel
 */
export class PrizeWheelLights extends PIXI.Sprite {
    constructor() {
        super();

        this.texture = PIXI.utils.TextureCache['mapui/prize-wheel-first-off'];
        this.anchor.set(0.5);
    }

    public setLight(state: boolean) {
        if (state) {
            this.rotation = (360 / 16) * DEG_TO_RAD;
        } else {
            this.rotation = 0;
        }
    }
}
